<template>
  <div
    :class="[`backdrop ${isOpenMenuSideBar ? 'show-backdrop' : ''}`]"
    @click="$emit('on-backdrop-click')"
  >
    <div
      :class="[`menu-sidebar ${isOpenMenuSideBar ? 'open-side-bar' : ''}`]"
      @click.stop=""
    >
      <div class="menu-header-block">
        <div class="menu-header-title">
          <p class="header-sub-title">{{ $t("bottomMenu.comeBack") }}</p>
          <h1 class="header-main-title">{{ $t("bottomMenu.active") }}</h1>
        </div>
        <img
          v-if="currentCustomer.img"
          :src="currentCustomer.img"
          alt=""
          class="menu-header-image-card"
        />
        <div v-else class="menu-header-image">
          <user-icon class="menu-header-image-icon" />
        </div>
      </div>
      <div class="menu-pages-list">
        <button class="menu-pages-item" @click="onOpenMainPage">
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <home-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">{{ $t("bottomMenu.myFin") }}</p>
          </div>
          <chevron-right-icon class="menu-item-active-page-icon" />
        </button>
        <button class="menu-pages-item" @click="onOpenAnalyticPage">
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <bar-chart-2-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">{{ $t("bottomMenu.analytic") }}</p>
          </div>
          <chevron-right-icon class="menu-item-active-page-icon" />
        </button>
        <button class="menu-pages-item" @click="onOpenSettingsPage">
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <settings-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">{{ $t("homePage.settings") }}</p>
          </div>
          <chevron-right-icon class="menu-item-active-page-icon" />
        </button>
        <button class="menu-pages-item" @click="onOpenPayPage">
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <shopping-bag-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">
              {{ $t("homePage.settingsPay") }}
              <!-- <span class="coming-soon">Cooming soon</span> -->
            </p>
          </div>
          <chevron-right-icon class="menu-item-active-page-icon" />
        </button>
        <button
          class="menu-pages-item"
          @click="$emit('on-open-change-color-block')"
        >
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <droplet-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">{{ $t("bottomMenu.themeColor") }}</p>
          </div>
          <chevron-right-icon class="menu-item-active-page-icon" />
        </button>
        <button class="menu-pages-item" @click="$emit('change-theme')">
          <div class="menu-item-name-block">
            <div class="menu-item-image">
              <user-icon class="menu-item-svg" />
            </div>
            <p class="menu-item-name">{{ $t("bottomMenu.darkTheme") }}</p>
          </div>
          <label class="switch">
            <input
              type="checkbox"
              :class="[`input ${isUseDarkMode ? 'checked' : ''}`]"
              @click="$emit('change-theme')"
            />
            <span class="slider"></span>
          </label>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  UserIcon,
  ChevronRightIcon,
  DropletIcon,
  SettingsIcon,
  BarChart2Icon,
  ShoppingBagIcon,
} from "vue-feather-icons";
import HomeIcon from "../icons/HomeIcon.vue";
import { setMakeDate } from "../../../helpers/utils";

export default {
  name: "Menu-block",
  components: {
    UserIcon,
    ChevronRightIcon,
    ShoppingBagIcon,
    DropletIcon,
    SettingsIcon,
    BarChart2Icon,
    HomeIcon,
  },
  props: {
    isUseDarkMode: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {};
  },
  async() {},

  methods: {
    onOpenMainPage() {
      this.$emit(
        "set-filter-operations-by-date",
        setMakeDate({ id: 1, value: this.$t("homePage.today") })
      );
      this.$emit("on-use-animation", 3);
      this.$emit("on-change-used-button", 2);
      this.$emit("on-backdrop-click");
    },
    onOpenAnalyticPage() {
      this.$emit("on-use-animation", 2);
      this.$emit("on-backdrop-click");
    },
    onOpenSettingsPage() {
      this.$emit("on-use-animation", 3);
      this.$emit("on-change-used-button", 1);
      this.$emit("on-backdrop-click");
    },
    onOpenPayPage() {
      this.$emit("on-use-animation", 5);
      this.$emit("on-backdrop-click");
    },
  },
  computed: {
    currentCustomer() {
      return this.$store.getters.currentCustomer;
    },
    isOpenMenuSideBar() {
      return this.$store.getters.isOpenMenuSideBar;
    },
  },
  watch: {},
};
</script>

<style scoped>
.menu-sidebar {
  position: absolute;
  width: 60%;
  height: 95%;
  top: 2.5%;
  left: 2.5%;
  padding-top: 70px;
  transform: translateX(-110%);
  pointer-events: all !important;
  backdrop-filter: saturate(180%) blur(80px);
  background-color: rgba(255, 255, 255, 0.8);
  pointer-events: none;
  z-index: 9999 !important;
  border: 0px !important;
  border-radius: 20px;
  transition: all 0.25s ease;
}

.theme-dark .menu-sidebar {
  background-color: rgba(19, 30, 43, 0.4);
}
.open-side-bar {
  transform: none;
}

.menu-header-block {
  display: flex;
  padding: 5px 0 30px 0;
  margin-left: 15px;
  margin-right: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.header-sub-title {
  margin-bottom: -6px;
  font-size: 13px;
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  color: #4a89dc;
  letter-spacing: -0.2px;
}

.header-main-title {
  font-size: 28px;
  margin-bottom: -3px;
  line-height: 30px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: #1b1b1b;
  font-family: "Source Sans 3", sans-serif;
}

.menu-header-image {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  width: 45px;
  height: 45px;
  transition: all 120ms ease;
  border-radius: 20px !important;
  border: none;
  background-image: var(--main-bg-color);
  position: relative;
  z-index: 10;
  overflow: visible !important;
  cursor: pointer;
}

.menu-header-image::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.85) translateY(5px) translateZ(10px);
  filter: blur(8px);
}

.menu-header-image-card {
  width: 45px;
  height: 45px;
  margin-left: auto;
  border-radius: 20px;
}

.menu-header-image-icon {
  color: #fff;
  margin: auto;
}

.menu-pages-list {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
  margin-left: 15px;
  margin-right: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.07);
}

.menu-pages-item {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  border: none;
  background: transparent;
}
.menu-item-name-block {
  display: flex;
  gap: 20px;
}

.menu-item-image {
  display: flex;
  position: relative;
  text-align: center;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 12px;
  background-image: var(--main-bg-color);
}

.menu-item-image::after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: inherit;
  z-index: -1;
  transform: scale(0.85) translateY(5px) translateZ(10px);
  filter: blur(8px);
}

.menu-item-svg {
  color: #fff;
  width: 18px;
  height: 18px;
  margin: auto;
}

.menu-item-name {
  font-family: "Source Sans 3", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  letter-spacing: -0.6px;
  line-height: 30px;
  cursor: pointer;
}

.menu-item-active-page-icon {
  color: #00000080;
  width: 10px;
  height: 10px;
  margin: auto 0;
}
/* ///////////////////////////// */

.switch {
  font-size: 17px;
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  margin: auto 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.07);
  transition: 0.4s;
  border-radius: 30px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  border-radius: 20px;
  left: 0px;
  bottom: 1px;
  z-index: 2;
  background-color: #fff;
  transition: 0.4s;
}

.input.checked + .slider {
  background-color: #8cc152;
}

.input:focus + .slider {
  box-shadow: 0 0 1px #183153;
}

.input.checked + .slider:before {
  transform: translateX(22px);
}

.coming-soon {
  background: #8cc152;
  padding: 1px 5px;
  border-radius: 10px;
  color: #fff;
  font-size: 10px;
  margin-left: 5px;
}
</style>
